import Model from '@/models/Model.js';

/**
 * The header banner's entity. It holds only the alerts the server says the current user
 * may see; authoring pages and the detail page keep their records elsewhere (H7).
 */
export default class SystemAlert extends Model {
    static entity = 'system_alerts';

    static modelName = 'SystemAlert';

    static fields() {
        return {
            id: this.attr(null),
            uuid: this.attr(null),
            course_id: this.attr(null),
            priority: this.attr(null),
            title: this.attr(null),
            caption: this.attr(null),
            body: this.attr(null),
            has_body: this.attr(null),
            icon: this.attr(null),
            color: this.attr(null),
            action_path: this.attr(null),
            location: this.attr(null),
            channels: this.attr(null),
            starts_at: this.attr(null),
            expires_at: this.attr(null),
            dismissable: this.boolean(true),
            notify_via_site: this.boolean(true),
            notify_via_email: this.boolean(false),
            notify_via_text: this.boolean(false),
            notify_via_push: this.boolean(false),
            notify_via_slack: this.boolean(false),

            ...super.fields(),

            course: this.belongsTo('courses', 'course_id'),
        };
    }

    static beforeSelect(systemAlerts) {
        return [...systemAlerts].sort((a, b) => {
            const priorityA = a.priority ?? Number.MAX_SAFE_INTEGER;
            const priorityB = b.priority ?? Number.MAX_SAFE_INTEGER;

            if (priorityA !== priorityB) {
                return priorityA > priorityB ? 1 : -1;
            }

            return (Number(a.id) || 0) - (Number(b.id) || 0);
        });
    }
}
